import React, { useState } from "react";
import {
  Box,
  Modal,
  Grid,
  TextField,
  MenuItem,
  FormLabel,
  FormHelperText,
  IconButton,
} from "@mui/material";
import styles from "../../styles/fabricationModal.module.css";
import axios from "axios";
import { Close, UploadFile } from "@mui/icons-material";
import imageCompression from "browser-image-compression";
import GlobalButton from "../../shared/utils/GlobalButton.jsx";

const FabricationModal = ({
  isOpen,
  formData,
  handleMainCategoryChange,
  handleChange,
  getMapping,
  handleSubmit,
  isOtherSelected,
  handleClose,
  setFabFormData,
  isEditing,
}) => {
  const mainCategories = [
    { value: "Welding Machine", label: "Welding Machine" },

    {
      value: "Paint Compressor Machine",
      label: "Paint Compressor Machine",
    },
    {
      value: "CNC Router Machine",
      label: "CNC Router Machine",
    },
    {
      value: "Acrylic Laser Cutting Machine",
      label: "Acrylic Laser Cutting Machine",
    },
    {
      value: "Channel Letter Bending Machine",
      label: "Channel Letter Bending Machine ",
    },
  ];

  // Sub-category options based on the main category selection
  const subCategories = {
    "Welding Machine": [
      { value: "Mig Welding Machine", label: "Mig Welding Machine" },
      { value: "Arc Welding Machine", label: "Arc Welding Machine" },
      { value: "Tig Welding Machine", label: "Tig Welding Machine" },
      { value: "Combi Welding Machine", label: "Combi Welding Machine" },
    ],
    "Acrylic Laser Cutting Machine": [
      {
        value: "Single Spindle",
        label: "Single Spindle",
      },
      {
        value: "Double Spindle",
        label: "Double Spindle",
      },
    ],
    "CNC Router Machine": [
      {
        value: "Single Spindle",
        label: "Single Spindle",
      },
      {
        value: "Double Spindle",
        label: "Double Spindle",
      },
    ],
    "Paint Compressor Machine": [
      {
        value: "Portable (2HP)",
        label: "Portable (2HP)",
      },
      {
        value: "Fixed (3HP & Above)",
        label: "Fixed (3HP & Above)",
      },
    ],
    "Pipe Cutting Machine": [
      {
        value: "Pipe",
        label: "Pipe",
      },
      {
        value: "Plate",
        label: "Plate",
      },
    ],
    "Channel Letter Bending Machine": [
      {
        value: "Stainless Steel(SS)",
        label: "Stainless Steel(SS)",
      },
      {
        value: "Aluminum",
        label: "Aluminum",
      },
      {
        value: "Hybrid",
        label: "Hybrid",
      },
    ],
  };

  // const brandNames = [
  //   {
  //     value: "CNC Router Machine",
  //     brandNames: ["Tiger Tek", "Mehta", "Umpire", "Chinese", "Other"],
  //   },
  //   {
  //     value: "Acrylic Laser Cutting Machine",
  //     brandNames: ["Tiger Tek", "Mehta", "Umpire", "Chinese", "Other"],
  //   },
  // ];
  const [uploadLoading, setUploadLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const currentSubCategories = subCategories[formData.category] || [];

  // const handleFileChange = async (e) => {
  //   const file = e.target.files[0];
  //   setUploadLoading(true);

  //   if (file) {
  //     if (file.size > 2 * 1024 * 1024) {
  //       setErrors((prev) => ({
  //         ...prev,
  //         document: "File is too large (max size: 2MB) ",
  //       }));
  //       setUploadLoading(false);
  //       e.target.value = "";

  //       alert("File is too large (max size: 2MB)");

  //       return;
  //     }

  //     const formDataNew = new FormData();
  //     formDataNew.append("files", file);

  //     try {
  //       const token = localStorage.getItem("token");
  //       const response = await axios.post(
  //         `${process.env.REACT_APP_URL}/upload`,
  //         formDataNew,
  //         {
  //           headers: {
  //             "Content-Type": "multipart/form-data",
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );

  //       if (response.data.success) {
  //         errors.document = "";
  //         setUploadLoading(false);
  //         setFabFormData({
  //           ...formData,
  //           fabricationMachineImage: response?.data?.data[0],
  //         });
  //         // setdocumentUrl(response?.data?.data[0]);
  //       }
  //     } catch (err) {
  //       console.error("Error uploading file", err);
  //       setErrors((prev) => ({
  //         ...prev,
  //         document: "Error while uploading file ",
  //       }));
  //       setUploadLoading(false);
  //     }
  //   }
  // };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    setUploadLoading(true);

    if (file) {
      try {
        const options = {
          maxSizeMB: 2,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };

        const compressedFile =
          file.size > 2 * 1024 * 1024
            ? await imageCompression(file, options)
            : file;

        const formDataNew = new FormData();
        formDataNew.append("files", compressedFile);

        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/upload`,
          formDataNew,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.data.success) {
          errors.document = "";
          setUploadLoading(false);
          setFabFormData({
            ...formData,
            fabricationMachineImage: response?.data?.data[0],
          });
        }
      } catch (err) {
        console.error("Error uploading file", err);
        setErrors((prev) => ({
          ...prev,
          document: "Error while uploading file ",
        }));
        setUploadLoading(false);
      }
    }
  };

  return (
    <Modal open={isOpen}>
      <Box className={styles["modal-box"]}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Main Category Dropdown */}
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                select
                fullWidth
                name="category"
                label="Select Category"
                value={formData.category || ""}
                onChange={handleMainCategoryChange}
                required
              >
                {mainCategories.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            {/* Sub Category Dropdown */}
            {formData.category && currentSubCategories?.length > 0 && (
              <Grid item xs={12} sm={6} md={6}>
                <TextField
                  select
                  fullWidth
                  label="Select Machine Type"
                  name="subCategory"
                  value={formData.subCategory || ""}
                  onChange={handleChange}
                  required
                >
                  {currentSubCategories.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            )}
            {formData?.category === "CNC Router Machine" && (
              <>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    fullWidth
                    select // Enables dropdown
                    label="Power of Machine"
                    name="powerOfMachine" // Name to store value in formData
                    value={formData?.powerOfMachine || ""}
                    onChange={handleChange}
                    required
                  >
                    <MenuItem value={2.5}>2.5 kW</MenuItem>
                    <MenuItem value={3.5}>3.5 kW</MenuItem>
                    <MenuItem value={4.5}>4.5 kW</MenuItem>
                    <MenuItem value={6}>6 kW</MenuItem>
                    <MenuItem value={7.5}>7.5 kW</MenuItem>
                  </TextField>
                </Grid>
              </>
            )}

            {formData?.category === "Hand Grinder Machine" && (
              <Grid item xs={12} sm={6} md={6}>
                <TextField
                  fullWidth
                  label="Machine Size (inches)"
                  name="machineSize"
                  type="number" // Set input type to number
                  value={formData?.machineSize || ""}
                  onChange={handleChange}
                  required
                  inputProps={{
                    min: 0, // Optional: Prevent negative values
                  }}
                />
              </Grid>
            )}

            <Grid item xs={12} sm={6} md={6}>
              <TextField
                select // Enables dropdown
                fullWidth
                label="Age of Machine"
                name="ageOfMachine"
                value={formData?.ageOfMachine || ""}
                onChange={handleChange}
                required
              >
                <MenuItem value="0-4">0 to 4 years</MenuItem>
                <MenuItem value="4+">4 years and above</MenuItem>
              </TextField>
            </Grid>
            {formData?.category === "Channel Letter Bending Machine" && (
              <Grid item xs={12} sm={6} md={6}>
                <TextField
                  fullWidth
                  select // Enables dropdown
                  label="Wattage of Machine"
                  name="wattage"
                  value={formData?.wattage || ""}
                  onChange={handleChange}
                  required
                >
                  <MenuItem value={1500}>1500 W</MenuItem>
                  <MenuItem value={200}>200 W</MenuItem>
                  <MenuItem value={800}>800 W</MenuItem>
                </TextField>
              </Grid>
            )}

            {formData?.category === "Channel Letter Bending Machine" && (
              <Grid item xs={12} sm={6} md={6}>
                <TextField
                  fullWidth
                  select // Enables dropdown
                  label="Machine Model"
                  name="modelMachine"
                  value={formData?.modelMachine || ""}
                  onChange={handleChange}
                  required
                >
                  <MenuItem value="Flat Aluminum">Flat Aluminum</MenuItem>
                  <MenuItem value={"Trim Cap Aluminum"}>
                    Trim Cap Aluminum
                  </MenuItem>
                </TextField>
              </Grid>
            )}

            {/* {(formData?.category === "CNC Router Machine" ||
              formData?.category === "Acrylic Laser Cutting Machine") && (
              <>
                <Grid item xs={12} sm={6} md={6} className="flex gap-1">
                  <TextField
                    name="machineLength"
                    value={formData?.machineLength || ""}
                    fullWidth
                    type="text"
                    label="Length"
                    onChange={(e) => {
                      const { value } = e.target;
                      const numericValue = value.replace(/[^0-9]/g, "");
                      const updatedValue = numericValue
                        ? `${numericValue}`
                        : "";
                      handleChange({
                        target: { name: "machineLength", value: updatedValue },
                      });
                    }}
                    required
                    inputProps={{
                      inputMode: "numeric",
                    }}
                  />
                  <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      select
                      fullWidth
                      label="Unit"
                      name="unitLength"
                      value={formData?.unitLength}
                      onChange={handleChange}
                      required
                    >
                      <MenuItem key={"feet"} value={"feet"}>
                        {"feet"}
                      </MenuItem>
                      <MenuItem key={"inch"} value={"inch"}>
                        {"inch"}
                      </MenuItem>
                    </TextField>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={6} className="flex gap-1">
                  <TextField
                    fullWidth
                    type="text" // Still use text to manage display flexibility
                    label="Breadth"
                    name="machineBreadth"
                    value={formData?.machineBreadth || ""}
                    onChange={(e) => {
                      const { value } = e.target;
                      const numericValue = value.replace(/[^0-9]/g, "");
                      const updatedValue = numericValue
                        ? `${numericValue}`
                        : "";
                      handleChange({
                        target: { name: "machineBreadth", value: updatedValue },
                      });
                    }}
                    required
                    inputProps={{
                      inputMode: "numeric", // Brings up numeric keypad on mobile devices
                    }}
                  />

                  <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      select
                      fullWidth
                      label="Unit"
                      name="unitBreadth"
                      value={formData?.unitBreadth}
                      onChange={handleChange}
                      required
                    >
                      <MenuItem key={"feet"} value={"feet"}>
                        {"feet"}
                      </MenuItem>
                      <MenuItem key={"inch"} value={"inch"}>
                        {"inch"}
                      </MenuItem>
                    </TextField>
                  </Grid>
                </Grid>
              </>
            )} */}

            {(formData?.category === "CNC Router Machine" ||
              formData?.category === "Acrylic Laser Cutting Machine" ||
              formData?.category === "Channel Letter Bending Machine") && (
              <>
                {formData?.category === "Acrylic Laser Cutting Machine" && (
                  <Grid item xs={12} sm={6} md={6}></Grid>
                )}
                <Grid item xs={12} sm={6} md={6}>
                  {/* <InputLabel className="mb-1"></InputLabel> */}
                  <TextField
                    fullWidth
                    label="Length (foot)"
                    select
                    name="lengthFoot"
                    value={formData.lengthFoot}
                    onChange={handleChange}
                    required
                  >
                    {Object.keys(getMapping()).map((key) => (
                      <MenuItem key={key} value={key}>
                        {key}'
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {/* Width (Breadth) - Auto Updated */}
                <Grid item xs={12} sm={6} md={6}>
                  {/* <InputLabel className="mb-1">Breadth (foot)*</InputLabel> */}
                  <TextField
                    fullWidth
                    label="Breadth (foot)"
                    name="breadthFoot"
                    value={
                      formData.breadthFoot ? `${formData.breadthFoot}'` : ""
                    } // Ensure valid value
                    InputProps={{
                      readOnly: true, // Prevent manual editing
                    }}
                    required
                  />
                </Grid>
              </>
            )}

            {formData.category === "Welding Machine" && (
              <>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    fullWidth
                    select // Enables dropdown
                    label="Ampere of Machine"
                    name="ampereOfMachine" // Updated spelling
                    value={formData?.ampereOfMachine || ""}
                    onChange={handleChange}
                    required
                  >
                    <MenuItem value={200}>200 A</MenuItem>
                    <MenuItem value={300}>300 A</MenuItem>
                    <MenuItem value={400}>400 A</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    fullWidth
                    select // Enables dropdown
                    label="Controller Setting"
                    name="controllerSetting" // Updated spelling
                    value={formData?.controllerSetting || ""}
                    onChange={handleChange}
                    required
                  >
                    <MenuItem value={"Digital"}> Digital</MenuItem>
                    <MenuItem value={"Manual"}> Manual</MenuItem>
                  </TextField>
                </Grid>
              </>
            )}

            {uploadLoading ? (
              <Grid item xs={12} sm={6} md={6}>
                <FormHelperText>Waiting...</FormHelperText>
              </Grid>
            ) : formData.fabricationMachineImage ? (
              <Grid item xs={12} sm={6} md={6}>
                <Box
                  sx={{
                    position: "relative",
                    display: "inline-block",
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    p: 1,
                    ml: 2,
                  }}
                >
                  <img
                    src={formData.fabricationMachineImage}
                    alt="Fabrication Machine"
                    style={{
                      maxWidth: "100px",
                      maxHeight: "100px",
                      borderRadius: "4px",
                    }}
                  />
                  <IconButton
                    size="small"
                    sx={{
                      position: "absolute",
                      top: -8,
                      right: -8,
                      background: "white",
                      boxShadow: 1,
                    }}
                    onClick={() =>
                      setFabFormData((prev) => ({
                        ...prev,
                        fabricationMachineImage: "",
                      }))
                    }
                  >
                    <Close fontSize="small" />
                  </IconButton>
                </Box>
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <FormLabel className="text-[14px]">Upload Image:</FormLabel>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mt: 1,
                  }}
                >
                  <input
                    accept="image/*"
                    id="upload-image"
                    type="file"
                    style={{ display: "none" }}
                    onChange={(e) => handleFileChange(e)}
                    className="w-full"
                  />
                  <label htmlFor="upload-image">
                    <IconButton
                      component="span"
                      sx={{
                        border: "1px dashed #ccc",
                        p: 1,
                        borderRadius: "8px",
                        bgcolor: "#f5f5f5",
                        ":hover": { bgcolor: "#e0e0e0" },
                      }}
                    >
                      <UploadFile />
                    </IconButton>
                  </label>
                </Box>
              </Grid>
            )}

            {/* Form Buttons */}

            <Grid container spacing={2}>
              <Grid item xs={6} mt={2}></Grid>
              <Grid item xs={3} mt={2}>
                <GlobalButton
                  variant="secondary"
                  size="small"
                  onClick={handleClose}
                >
                  {`Close`}
                </GlobalButton>
              </Grid>
              <Grid item xs={3} mt={2}>
                <GlobalButton type="submit" variant="primary" size="small">
                  {isEditing ? "Update" : "Save"}
                </GlobalButton>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Modal>
  );
};

export default FabricationModal;
